import type { UserRole } from '@jq4race/shared';

/** Roles that can be assigned to a location (spec FR-02). */
export const ASSIGNABLE_ROLES: UserRole[] = ['supervisor', 'operator'];
